import React from "react";

export const SkipToContent = () => (
  <a
    href="#main"
    className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-full focus:bg-brand-blue focus:text-white focus:shadow-md focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-brand-blue"
    data-testid="skip-to-content"
  >
    Skip to content
  </a>
);

export default SkipToContent;
